import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[idpSwapIconClick]'
})
export class SwapIconClickDirective {
  @Output() swapClicked = new EventEmitter<void>();
  @HostListener('click', ['$event'])
  onClick(event: Event) {
    const isSwapIconClicked = [
      'route-picker__swap-arrow', //one-way/round-trip
      'multi-route-picker__swap-arrow' //multi-city
    ].some((className) =>
      (event.target as HTMLElement).classList.contains(className)
    );
    isSwapIconClicked && this.swapClicked.emit();
  }
}
